<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="700px"
    bodyHeight="500px"
    class="edit-modal"
    :append-to-body="true"
    @close="onChange"
  >
    <div slot="title">
      {{ $t('shop-site::facebook_token::title') }}
    </div>
    <div class="modal-tip">
      <p>
        <i class="icon-a-01wenhao iconfont-el"></i>
        {{ $t('shop-site::facebook_token::tip') }}
      </p>
    </div>
    <el-button type="primary" @click="handleItem" class="mb-16">
      {{ $t('shop-site::facebook_token::add_button') }}
    </el-button>

    <el-form ref="form" :model="params" label-width="0">
      <el-table
        class="user-body"
        ref="table"
        :data="params.tokens"
        style="width: 100%"
        height="300"
        v-loading="loading"
      >
        <el-table-column :label="$t('shop-site::facebook_token::table_name')" prop="appName" width="150px">
          <template slot-scope="{ row, $index }">
            <el-form-item
              :key="$index"
              v-if="row.type !== 'none'"
              :prop="`tokens.${$index}.appName`"
              :rules="[
                {
                  required: true,
                  message: $t('shop-site::facebook_token::placeholder_name'),
                  trigger: 'change',
                },
              ]"
            >
              <el-input
                :placeholder="$t('shop-site::facebook_token::placeholder_name')"
                class="input-item"
                v-model.trim="row.appName"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <template v-else>{{ row.appName }}</template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('shop-site::facebook_token::table_token')" prop="accessToken" min-width="150px">
          <template slot-scope="{ row, $index }">
            <el-form-item
              :key="$index"
              v-if="row.type !== 'none'"
              :prop="`tokens.${$index}.accessToken`"
              :rules="[
                {
                  required: true,
                  message: $t('shop-site::facebook_token::placeholder_token'),
                  trigger: 'change',
                },
              ]"
            >
              <el-input
                :placeholder="$t('shop-site::facebook_token::placeholder_token')"
                type="textarea"
                maxlength="500"
                class="input-item"
                v-model.trim="row.accessToken"
              ></el-input>
            </el-form-item>
            <template v-else>{{ row.accessToken }}</template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('shop-site::facebook_token::table_time')" width="200px">
          <template slot-scope="{ row }">
            {{ $dataCheck(row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('shop-site::facebook_token::table_handle')" width="140px">
          <template slot-scope="{ row, $index }">
            <el-button v-if="row.type === 'none'" @click="handleBtn('edit', row)" type="text">
              {{ $t('shop-site::facebook_token::table_edit') }}
            </el-button>
            <el-button
              v-if="row.type !== 'none'"
              @click="handleBtn('save', row, $index)"
              :loading="row.loading"
              type="text"
            >
              {{ $t('shop-site::facebook_token::table_save') }}
            </el-button>
            <el-button v-if="row.type !== 'none'" @click="handleBtn('none', row)" type="text">
              {{ $t('shop-site::facebook_token::table_cancel') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">取 消</el-button>
      <el-button type="primary" @click="onSave" :loading="loading">确定</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
import { getTokenAdsList, accountSaveToken } from '@/server/marketing.js'
import { getShopList } from '@/server/shopList.js'
export default {
  name: 'token-modal',
  components: {},
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    drawRow: {
      default: () => {},
    },
  },
  watch: {
    visible(bool) {
      this.show = bool
      if (bool) {
        this.getTokenList()
      } else {
        this.$emit('close')
      }

      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true,
    },
  },
  data() {
    return {
      loading: false,
      tokensLoading: false,
      params: {},

      show: false,
    }
  },
  mounted() {},
  methods: {
    handleItem() {
      this.$refs.table.$refs.bodyWrapper.scrollTop = 0
      this.params.tokens.unshift({
        appName: '',
        accessToken: '',
        updateTime: '',
        editTokenDefault: null,
        type: 'edit',
        loading: false,
      })
    },
    async getTokenList() {
      this.loading = true
      const { data } = await getTokenAdsList()
      if (data.code === this.$code) {
        this.params.tokens = data.data.map(item => {
          return {
            ...item,
            type: 'none',
            editTokenDefault: null,
            loading: false,
          }
        })
      }
      this.loading = false
    },
    onChange() {
      this.$emit('change', false)
    },
    async handleBtn(type, row, index) {
      row.type = type
      if (type === 'none') {
        if (!row.editTokenDefault) {
          this.params.tokens.shift()
          return false
        }
        row.editTokenDefault.type = 'none'
        row = Object.assign(row, row.editTokenDefault)
        this.editTokenDefault = null
      } else if (type === 'edit') {
        row.editTokenDefault = this.$deepClone(row)
        row.type = type
      } else if (type === 'save') {
        let err = 0
        this.$refs['form'].validateField([`tokens.${index}.appName`, `tokens.${index}.accessToken`], valid => {
          if (valid) {
            err += 1
          }
        })
        if (err === 0) {
          row.loading = true
          let params = {
            appName: row.appName,
            accessToken: row.accessToken,
          }
          if (row.id) {
            params.id = row.id
          }
          const { data } = await accountSaveToken(params)
          row.loading = false
          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.getTokenList()
          }
          row.editTokenDefault = null
          row.type = 'none'
        } else {
          row.type = 'edit'
        }
      }
    },
    handleCheck(type) {
      this.$refs.form.resetFields()
      this.params.type = type
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-modal {
  .modal-tip {
    margin-bottom: 12px;
  }
  .user-body {
    .input-item {
      width: 100%;
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
</style>
